import Vue from 'vue';
import { POSITION, TYPE } from 'vue-toastification';
import HMToast from '@/web/components/common/HMToast.vue';

export function notificationToToast(data) {
  let timeout;
  if (data.duration === -1) {
    timeout = false;
  } else if (!data.duration) {
    timeout = 3000;
  } else {
    timeout = data.duration;
  }

  const icons = {
    [TYPE.SUCCESS]: 'fas fa-check',
    [TYPE.ERROR]: 'fas fa-exclamation',
  };

  return {
    content: {
      component: HMToast,
      props: {
        title: data.title,
        text: data.text,
      },
    },
    config: {
      timeout,
      position: POSITION.BOTTOM_LEFT,
      type: data.type,
      icon: icons[data.type],
    },
  };
}

export function notify(title: string, text: string, duration = 3000) {
  const data = {
    type: 'success',
    title,
    text,
    duration,
  };
  const { content, config } = notificationToToast(data);
  Vue.$toast(content, config);
}
